import { UserOnPaytmMembershipPlanResultAjax } from './user-on-paytm-membership-plan.backend-model';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    userOnPaytmMembershipPlan: UserOnPaytmMembershipPlanResultAjax;
  }
}

export const userOnPaytmMembershipPlanBackend = {
  fetch: () => ({
    endpoint: `memberships/isUserOnPaytmMembershipPlan.php`,
    isGaf: true,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-on-paytm-membership-plan/user-on-paytm-membership-plan.backend.ts